import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2>Coming soon</h2>
        </div>
    );
};

export default Payment;